import React from "react";
import { useNavigate } from "react-router-dom";
import { useSiteContent } from "../context/SiteContentContext";
import { mediaUrl } from "../lib/api";
import { Crown } from "lucide-react";

export default function SpotlightDen() {
  const { content } = useSiteContent();
  const navigate = useNavigate();
  const images = content.spotlight_den_images || [];

  const openLink = (uri) => {
    try {
      const u = new URL(uri, window.location.origin);
      // internal profile links -> route within the app
      const m = u.pathname.match(/\/profile\/([\w-]+)/);
      if (m && /thetopspotter\.com$/i.test(u.hostname.replace(/^www\./, ""))) {
        navigate(`/profile/${m[1]}`);
        return;
      }
    } catch (e) {}
    window.open(uri, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="max-w-3xl mx-auto" data-testid="spotlight-den-page">
      <div className="flex items-center justify-center gap-2 mb-4">
        <Crown className="w-7 h-7" style={{ color: "#E19C00" }} />
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-spotter-maroon" data-testid="spotlight-title">{content.spotlight_den_title || "The Spotlight Den"}</h1>
      </div>

      <div className="bg-white border-4 border-black rounded-2xl overflow-hidden brand-shadow" data-testid="spotlight-card">
        {images.length > 0 ? (
          <>
            {images.map((img, i) => (
              <div key={i} className="relative w-full leading-none" data-testid={`spotlight-image-${i}`}>
                <img src={mediaUrl(img.url)} alt={`Spotlight Den page ${i + 1}`} className="w-full block select-none" draggable={false} />
                {(img.links || []).map((lk, j) => (
                  <button
                    key={j}
                    data-testid={`spotlight-hotspot-${i}-${j}`}
                    onClick={() => openLink(lk.uri)}
                    title={lk.uri}
                    aria-label={lk.uri}
                    className="absolute cursor-pointer hover:bg-spotter-gold/25 rounded-sm transition-colors"
                    style={{
                      left: `${lk.x0 * 100}%`,
                      top: `${lk.y0 * 100}%`,
                      width: `${(lk.x1 - lk.x0) * 100}%`,
                      height: `${(lk.y1 - lk.y0) * 100}%`,
                    }}
                  />
                ))}
              </div>
            ))}
          </>
        ) : (
          <div className="text-center py-16 text-spotter-maroon" data-testid="spotlight-empty">
            <Crown className="w-12 h-12 mx-auto mb-3" style={{ color: "#E19C00" }} />
            <p className="font-heading font-bold text-lg">Nothing here yet.</p>
            <p className="text-sm">Upload the Spotlight Den PDF in Site Content. 🐆</p>
          </div>
        )}
      </div>
    </div>
  );
}
